import { useState } from "react";
import { Link, createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AuthFrame, AuthHead, Notice } from "@/components/AuthFrame";
import { Icon } from "@/components/Icon";
import { authErrorText } from "@/features/auth/errors";
import { requestPasswordReset } from "@/lib/auth";

// Forgot the password (I-m-vergeten): a link by mail, whether the address is known or not the answer is
// the same. The new password asks the code from the app too, so a mailbox alone is not enough.

export const Route = createFileRoute("/forgot")({
  component: ForgotScreen,
});

function ForgotScreen() {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async () => {
    setBusy(true);
    setError(null);
    try {
      await requestPasswordReset(email);
      setSent(true);
    } catch (err) {
      setError(authErrorText(t, err, i18n.language));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthFrame label="Portaal Wachtwoord vergeten">
      <div>
        <Link to="/login" className="wl-btn wl-btn--link">
          <Icon name="arrowLeft" />
          {t("common.backToSignIn")}
        </Link>
      </div>
      <AuthHead title={t("forgot.title")} lead={t("forgot.lead")} />
      {error && <Notice tone="danger">{error}</Notice>}
      {sent ? (
        <Notice tone="success">{t("forgot.sent")}</Notice>
      ) : (
        <form
          className="wl-vstack"
          style={{ gap: "var(--space-5)", alignItems: "stretch" }}
          onSubmit={(event) => {
            event.preventDefault();
            void submit();
          }}
        >
          <div className="wl-field">
            <label className="wl-field__label" htmlFor="forgot-email">
              {t("login.email")}
            </label>
            <input
              id="forgot-email"
              className="wl-input"
              type="email"
              autoComplete="username"
              value={email}
              autoFocus
              onChange={(event) => setEmail(event.target.value)}
            />
          </div>
          <div className="wl-auth__actions">
            <span className="wl-spacer" />
            <button type="submit" className="wl-btn wl-btn--primary wl-btn--lg" disabled={busy || !email.includes("@")}>
              {t("forgot.submit")}
            </button>
          </div>
        </form>
      )}
      <Notice tone="neutral">{t("forgot.codeToo")}</Notice>
    </AuthFrame>
  );
}
